import { toXlsxData, toXlsxColumns } from 'core/component/xlsx-utils-excel'
import R from 'ramda'

export const getWind2PlantXLSX = (data, headers) => {
  const columns = toXlsxColumns(headers)
  const ed = toXlsxData(data, headers)
  const worksheets = [
    {
      name: 'Plant',
      columns,
      data: ed,
      metaInfo: [],
    },
  ]
  return worksheets
}

export const getWind2SubgroupXLSX = (data, headers) => {
  const columns = toXlsxColumns(headers)
  const ed = toXlsxData(data, headers)
  const worksheets = [
    {
      name: 'Subgroup',
      columns,
      data: ed,
      metaInfo: [],
    },
  ]
  return worksheets
}

export const getWind2EventNestedXLSX = (data, headers) => {
  const columns = toXlsxColumns(headers)
  const ed = toXlsxData(data, headers)
  const worksheets = [
    {
      name: 'Event',
      columns,
      data: ed,
      metaInfo: [],
    },
  ]
  return worksheets
}

export const getWind2SubgroupPerformanceXLSX = (data, headers) => {
  const columns = toXlsxColumns(headers)
  const ed = toXlsxData(data, headers)
  const worksheets = [
    {
      name: 'Subgroup Performance',
      columns,
      data: ed,
      metaInfo: [],
    },
  ]
  return worksheets
}

export const getWind2EventSubgroupPerformanceXLSX = (
  data1,
  headers1,
  data2,
  headers2
) => {
  const columns1 = toXlsxColumns(headers1)
  const ed1 = toXlsxData(data1, headers1)
  const columns2 = toXlsxColumns(headers2)
  const ed2 = toXlsxData(data2, headers2)

  const worksheets = [
    {
      name: 'Event',
      columns: columns1,
      data: ed1,
      metaInfo: [],
    },
    {
      name: 'Subgroup Performance',
      columns: columns2,
      data: ed2,
      metaInfo: [],
    },
  ]

  return worksheets
}

export const getWind2StorageXLSX = (data, headers) => {
  const ehd = R.compose(
    R.sortWith([R.ascend(R.prop('ord'))]),
    R.map(d => ({
      ...d,
      display: d.xd || d.display,
      width: (d.width || 100) * 2,
    }))
  )(headers)

  const columns = toXlsxColumns(ehd)

  const ed = toXlsxData(data, headers)
  const worksheets = [
    {
      name: 'Storage',
      columns,
      data: ed,
      metaInfo: [],
    },
  ]
  return worksheets
}

export const getWind2StoragePerformanceXLSX = (data, headers) => {
  const ehd = R.compose(
    R.sortWith([R.ascend(R.prop('ord'))]),
    R.map(d => ({
      ...d,
      display: d.xd || d.display,
      width: (d.width || 100) * 2,
    }))
  )(headers)

  const columns = toXlsxColumns(ehd)

  const ed = toXlsxData(data, headers)
  const worksheets = [
    {
      name: 'Storage Performance',
      columns,
      data: ed,
      metaInfo: [],
    },
  ]
  return worksheets
}
